import React from 'react';
import { connect } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { FormattedMessage, useIntl } from 'react-intl';

import { Page, LayoutSingleColumn, IconSpinner, ListingCard } from '../../components';
import TopbarContainer from '../../containers/TopbarContainer/TopbarContainer';
import FooterContainer from '../../containers/FooterContainer/FooterContainer';

import { loadData, removeFromWishlist } from './WishListPage.duck';
import css from './WishListPage.module.css';
import { isScrollingDisabled } from '../../ducks/ui.duck';

const WishlistItem = props => {
  const { listing, onRemove, isToggling } = props;
  const isFeatured = listing?.attributes?.publicData?.isFeatured;

  return (
    <div className={css.cardWrapper}>
      <ListingCard listing={listing} showAuthorInfo={false} />
    </div>
  );
};

export const WishListPageComponent = props => {
  const location = useLocation();
  const {
    queryInProgress,
    wishlistListings,
    onRemoveFromWishlist,
    toggleWishlistInProgress,
    toggleWishlistError,
    togglingId,
  } = props;
  const intl = useIntl();

  const pageTitle = intl.formatMessage({ id: 'WishListPage.title' });

  const error = toggleWishlistError ? (
    <div className={css.error}>
      <FormattedMessage id="WishListPage.error" />
    </div>
  ) : null;
  const urlParams = new URLSearchParams(location.search);
  const hasMobileMenuOpen = urlParams.get('mobilemenu') === 'open';

  return (
    <Page title={"WishList"}
      {...(hasMobileMenuOpen ? { scrollingDisabled: isScrollingDisabled } : {})}
    >
      <LayoutSingleColumn
        topbar={<TopbarContainer />}
        footer={<FooterContainer />}
      >
        <div className={css.root}>
          <div className={css.pageContainer}>
            <h1 className={css.title}>{pageTitle}</h1>
            {error}
            {queryInProgress ? (
              <div className={css.loadingSpinner}>
                <IconSpinner />
              </div>
            ) : wishlistListings.length > 0 ? (
              <div className={css.listingGrid}>
                {wishlistListings.map(listing => (
                  <WishlistItem
                    key={listing.id.uuid}
                    listing={listing}
                    onRemove={onRemoveFromWishlist}
                    isToggling={toggleWishlistInProgress && togglingId === listing.id.uuid}
                  />
                ))}
              </div>
            ) : (
              <div className={css.noItems}>
                <FormattedMessage id="WishListPage.noItems" />
              </div>
            )}
          </div>
        </div>
      </LayoutSingleColumn>
    </Page>
  );
};

const mapStateToProps = state => {
  const {
    wishlistListings,
    queryInProgress,
    toggleWishlistInProgress,
    toggleWishlistError,
    togglingId,
  } = state.WishListPage;
  return {
    wishlistListings,
    queryInProgress,
    toggleWishlistInProgress,
    toggleWishlistError,
    togglingId,
  };
};

const mapDispatchToProps = dispatch => ({
  onRemoveFromWishlist: listingId => dispatch(removeFromWishlist(listingId)),
});

const WishListPage = connect(
  mapStateToProps,
  mapDispatchToProps
)(WishListPageComponent);

WishListPage.loadData = ( config) => {
  return loadData(config);
};

export default WishListPage;